/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ProjektMappe } from '../models/projekt-mappe';
import { MitProjekt } from '../models/mit-projekt';
import { ProjektMappeReference } from '../models/projekt-mappe-reference';
import { Projekt } from '../models/projekt';
import { CreateProjektRequest } from '../models/create-projekt-request';
import { PublicProjekt } from '../models/public-projekt';
import { ProjektSted } from '../models/projekt-sted';
import { PublicProjektSagKorrespondance } from '../models/public-projekt-sag-korrespondance';
import { KonfliktTypeGrouping } from '../models/konflikt-type-grouping';
import { SagKonflikt } from '../models/sag-konflikt';
import { KonfliktTypeReference } from '../models/konflikt-type-reference';
import { PublicProjektRettigheder } from '../models/public-projekt-rettigheder';
import { PublicProjektRettighed } from '../models/public-projekt-rettighed';
import { ActivateProjectInvitationTicketResult } from '../models/activate-project-invitation-ticket-result';
import { MoveProjekterRequest } from '../models/move-projekter-request';
import { PublicVirksomhedProjekt } from '../models/public-virksomhed-projekt';
import { ProjektejerRequest } from '../models/projektejer-request';
import { ForaeldetAktivitetTypePar } from '../models/foraeldet-aktivitet-type-par';
import { ProjektReference } from '../models/projekt-reference';
@Injectable({
  providedIn: 'root',
})
class ProjekterService extends __BaseService {
static readonly getProjektMapperPath = '/projekter/projektmapper';
static readonly getMineProjekterForMappePath = '/projekter/projekterformappe';
static readonly createPath = '/projekter';
static readonly getPath = '/projekter/{projektId}';
static readonly sletPath = '/projekter/{projektId}';
static readonly getProjektStedPath = '/projekter/{projektId}/sted';
static readonly omdoebPath = '/projekter/{projektId}/omdoeb';
static readonly setEjendomsejerPath = '/projekter/{projektId}/ejendomsejer';
static readonly setNoEjendomsejerPath = '/projekter/{projektId}/noejendomsejer';
static readonly setProjektKontaktInformationPath = '/projekter/{projektId}/kontakt';
static readonly getBeskederPath = '/projekter/{projektId}/beskeder';
static readonly genberegnPath = '/projekter/{projektId}/genberegn';
static readonly getKonfliktGrupperPath = '/projekter/{projektId}/konfliktgrupper';
static readonly getKonflikterPath = '/projekter/{projektId}/konflikter';
static readonly getProjektRettighederPath = '/projekter/{projektId}/rettigheder';
static readonly inviterPath = '/projekter/{projektId}/inviter';
static readonly getProjektRettighedPath = '/projekter/{projektId}/rettighed';
static readonly setProjektRettighedPath = '/projekter/{projektId}/setRettighed';
static readonly sletProjektRettighedPath = '/projekter/{projektId}/sletRettighed';
static readonly accepterInvitationPath = '/projekter/accepterinvitation';
static readonly tilbagekaldInvitationPath = '/projekter/tilbagekaldinvitation/{invitationId}';
static readonly createMappePath = '/projekter/opretmappe';
static readonly deleteMappePath = '/projekter/sletmappe';
static readonly renameMappePath = '/projekter/omdøbmappe';
static readonly moveProjekterToMappePath = '/projekter/flytprojekter';
static readonly getVirksomhedsProjekterPath = '/projekter/virksomhed';
static readonly setProjektejerPath = '/projekter/setprojektejer';
static readonly getForaeldetAktiviteterPath = '/projekter/getforaeldetaktivitet';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Henter alle brugerens projektmapper.
   * @return Success
   */
  private getProjektMapperResponse(): __Observable<__StrictHttpResponse<Array<ProjektMappe>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/projekter/projektmapper`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ProjektMappe>>;
      })
    );
  }

  /**
   * Henter alle brugerens projektmapper.
   * @return Success
   */
  getProjektMapper(): __Observable<Array<ProjektMappe>> {
    return this.getProjektMapperResponse().pipe(
      __map(_r => _r.body as Array<ProjektMappe>)
    );
  }

  /**
   * Henter alle projekter for en mappe.
   * @param mappeReference Reference til mappen der ønskes hentet projekter for.
   * @return Success
   */
  private getMineProjekterForMappeResponse(mappeReference: ProjektMappeReference): __Observable<__StrictHttpResponse<Array<MitProjekt>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = mappeReference;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter/projekterformappe`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<MitProjekt>>;
      })
    );
  }

  /**
   * Henter alle projekter for en mappe.
   * @param mappeReference Reference til mappen der ønskes hentet projekter for.
   * @return Success
   */
  getMineProjekterForMappe(mappeReference: ProjektMappeReference): __Observable<Array<MitProjekt>> {
    return this.getMineProjekterForMappeResponse(mappeReference).pipe(
      __map(_r => _r.body as Array<MitProjekt>)
    );
  }

  /**
   * Opretter et projekt.
   * @param createProjektRequest Projektet der skal oprettes.
   * @return Success
   */
  private createResponse(createProjektRequest: CreateProjektRequest): __Observable<__StrictHttpResponse<Projekt>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = createProjektRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Projekt>;
      })
    );
  }

  /**
   * Opretter et projekt.
   * @param createProjektRequest Projektet der skal oprettes.
   * @return Success
   */
  create(createProjektRequest: CreateProjektRequest): __Observable<Projekt> {
    return this.createResponse(createProjektRequest).pipe(
      __map(_r => _r.body as Projekt)
    );
  }

  /**
   * Henter nuværende version af et projekt.
   * @param projektId Projektets ID.
   * @return Success
   */
  private getResponse(projektId: string): __Observable<__StrictHttpResponse<PublicProjekt>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/projekter/${encodeURIComponent(String(projektId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PublicProjekt>;
      })
    );
  }

  /**
   * Henter nuværende version af et projekt.
   * @param projektId Projektets ID.
   * @return Success
   */
  get(projektId: string): __Observable<PublicProjekt> {
    return this.getResponse(projektId).pipe(
      __map(_r => _r.body as PublicProjekt)
    );
  }

  /**
   * Sletter et projekt.
   * Hvis projektet ikke er i stand til at blive slettet (f.eks, hvis det indeholder ansøgninger som er indendt),
   * vil der blive kastet 403 exception.
   * @param projektId Projektets ID.
   */
  private sletResponse(projektId: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/projekter/${encodeURIComponent(String(projektId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * Sletter et projekt.
   * Hvis projektet ikke er i stand til at blive slettet (f.eks, hvis det indeholder ansøgninger som er indendt),
   * vil der blive kastet 403 exception.
   * @param projektId Projektets ID.
   */
  slet(projektId: string): __Observable<null> {
    return this.sletResponse(projektId).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Henter projektets sted.
   * @param projektId Projektets ID.
   * @return Success
   */
  private getProjektStedResponse(projektId: string): __Observable<__StrictHttpResponse<ProjektSted>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/projekter/${encodeURIComponent(String(projektId))}/sted`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ProjektSted>;
      })
    );
  }

  /**
   * Henter projektets sted.
   * @param projektId Projektets ID.
   * @return Success
   */
  getProjektSted(projektId: string): __Observable<ProjektSted> {
    return this.getProjektStedResponse(projektId).pipe(
      __map(_r => _r.body as ProjektSted)
    );
  }

  /**
   * Omdøber titlen på et projekt.
   * @param params The `ProjekterService.OmdoebParams` containing the following parameters:
   *
   * - `projektTitel`: Ny titel.
   *
   * - `projektId`: Projektets ID.
   */
  private omdoebResponse(params: ProjekterService.OmdoebParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.projektTitel != null) __params = __params.set('projektTitel', params.projektTitel.toString());

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter/${encodeURIComponent(String(params.projektId))}/omdoeb`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * Omdøber titlen på et projekt.
   * @param params The `ProjekterService.OmdoebParams` containing the following parameters:
   *
   * - `projektTitel`: Ny titel.
   *
   * - `projektId`: Projektets ID.
   */
  omdoeb(params: ProjekterService.OmdoebParams): __Observable<null> {
    return this.omdoebResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Sætter projekt ejer på et projekt.
   * @param params The `ProjekterService.SetEjendomsejerParams` containing the following parameters:
   *
   * - `projektId`: Projektets ID.
   *
   * - `ejerskabId`: ejerskabId.
   */
  private setEjendomsejerResponse(params: ProjekterService.SetEjendomsejerParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.ejerskabId != null) __params = __params.set('ejerskabId', params.ejerskabId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter/${encodeURIComponent(String(params.projektId))}/ejendomsejer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * Sætter projekt ejer på et projekt.
   * @param params The `ProjekterService.SetEjendomsejerParams` containing the following parameters:
   *
   * - `projektId`: Projektets ID.
   *
   * - `ejerskabId`: ejerskabId.
   */
  setEjendomsejer(params: ProjekterService.SetEjendomsejerParams): __Observable<null> {
    return this.setEjendomsejerResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Fjern projekt ejer på et projekt eller opdater begrundelse.
   * @param params The `ProjekterService.SetNoEjendomsejerParams` containing the following parameters:
   *
   * - `projektId`: Projektets Id.
   *
   * - `ejerskabIkkeSatBegrundelse`: Begrundelse for ikke at have en ejendomsejer.
   */
  private setNoEjendomsejerResponse(params: ProjekterService.SetNoEjendomsejerParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.ejerskabIkkeSatBegrundelse != null) __params = __params.set('ejerskabIkkeSatBegrundelse', params.ejerskabIkkeSatBegrundelse.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter/${encodeURIComponent(String(params.projektId))}/noejendomsejer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * Fjern projekt ejer på et projekt eller opdater begrundelse.
   * @param params The `ProjekterService.SetNoEjendomsejerParams` containing the following parameters:
   *
   * - `projektId`: Projektets Id.
   *
   * - `ejerskabIkkeSatBegrundelse`: Begrundelse for ikke at have en ejendomsejer.
   */
  setNoEjendomsejer(params: ProjekterService.SetNoEjendomsejerParams): __Observable<null> {
    return this.setNoEjendomsejerResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `ProjekterService.SetProjektKontaktInformationParams` containing the following parameters:
   *
   * - `projektId`:
   *
   * - `kontaktTlf`:
   *
   * - `kontaktNavn`:
   *
   * - `kontaktEmail`:
   *
   * - `kontaktAdresse`:
   *
   * - `kontaktCvr`:
   */
  private setProjektKontaktInformationResponse(params: ProjekterService.SetProjektKontaktInformationParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.kontaktTlf != null) __params = __params.set('kontaktTlf', params.kontaktTlf.toString());
    if (params.kontaktNavn != null) __params = __params.set('kontaktNavn', params.kontaktNavn.toString());
    if (params.kontaktEmail != null) __params = __params.set('kontaktEmail', params.kontaktEmail.toString());
    if (params.kontaktAdresse != null) __params = __params.set('kontaktAdresse', params.kontaktAdresse.toString());
    if (params.kontaktCvr != null) __params = __params.set('kontaktCvr', params.kontaktCvr.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter/${encodeURIComponent(String(params.projektId))}/kontakt`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * @param params The `ProjekterService.SetProjektKontaktInformationParams` containing the following parameters:
   *
   * - `projektId`:
   *
   * - `kontaktTlf`:
   *
   * - `kontaktNavn`:
   *
   * - `kontaktEmail`:
   *
   * - `kontaktAdresse`:
   *
   * - `kontaktCvr`:
   */
  setProjektKontaktInformation(params: ProjekterService.SetProjektKontaktInformationParams): __Observable<null> {
    return this.setProjektKontaktInformationResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Henter beskeder for et projekt.
   * @param projektId Projektets ID.
   * @return Success
   */
  private getBeskederResponse(projektId: string): __Observable<__StrictHttpResponse<Array<PublicProjektSagKorrespondance>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/projekter/${encodeURIComponent(String(projektId))}/beskeder`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PublicProjektSagKorrespondance>>;
      })
    );
  }

  /**
   * Henter beskeder for et projekt.
   * @param projektId Projektets ID.
   * @return Success
   */
  getBeskeder(projektId: string): __Observable<Array<PublicProjektSagKorrespondance>> {
    return this.getBeskederResponse(projektId).pipe(
      __map(_r => _r.body as Array<PublicProjektSagKorrespondance>)
    );
  }

  /**
   * Genberegner projektet.
   * @param projektId Projektets ID.
   * @return Success
   */
  private genberegnResponse(projektId: string): __Observable<__StrictHttpResponse<PublicProjekt>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/projekter/${encodeURIComponent(String(projektId))}/genberegn`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PublicProjekt>;
      })
    );
  }

  /**
   * Genberegner projektet.
   * @param projektId Projektets ID.
   * @return Success
   */
  genberegn(projektId: string): __Observable<PublicProjekt> {
    return this.genberegnResponse(projektId).pipe(
      __map(_r => _r.body as PublicProjekt)
    );
  }

  /**
   * Henter konfliktgrupper for et projekt.
   * @param projektId Projektets ID.
   * @return Success
   */
  private getKonfliktGrupperResponse(projektId: string): __Observable<__StrictHttpResponse<Array<KonfliktTypeGrouping>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/projekter/${encodeURIComponent(String(projektId))}/konfliktgrupper`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<KonfliktTypeGrouping>>;
      })
    );
  }

  /**
   * Henter konfliktgrupper for et projekt.
   * @param projektId Projektets ID.
   * @return Success
   */
  getKonfliktGrupper(projektId: string): __Observable<Array<KonfliktTypeGrouping>> {
    return this.getKonfliktGrupperResponse(projektId).pipe(
      __map(_r => _r.body as Array<KonfliktTypeGrouping>)
    );
  }

  /**
   * Henter konflikter for et projekt, udfra en liste af konflikttyper.
   * @param params The `ProjekterService.GetKonflikterParams` containing the following parameters:
   *
   * - `projektId`: Projektets ID.
   *
   * - `konfliktTyper`: Liste af konflikttyper der ønskes konflikter for.
   *
   * @return Success
   */
  private getKonflikterResponse(params: ProjekterService.GetKonflikterParams): __Observable<__StrictHttpResponse<Array<SagKonflikt>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.konfliktTyper;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter/${encodeURIComponent(String(params.projektId))}/konflikter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SagKonflikt>>;
      })
    );
  }

  /**
   * Henter konflikter for et projekt, udfra en liste af konflikttyper.
   * @param params The `ProjekterService.GetKonflikterParams` containing the following parameters:
   *
   * - `projektId`: Projektets ID.
   *
   * - `konfliktTyper`: Liste af konflikttyper der ønskes konflikter for.
   *
   * @return Success
   */
  getKonflikter(params: ProjekterService.GetKonflikterParams): __Observable<Array<SagKonflikt>> {
    return this.getKonflikterResponse(params).pipe(
      __map(_r => _r.body as Array<SagKonflikt>)
    );
  }

  /**
   * Henter rettigheder for et projekt.
   * @param projektId Projektets ID.
   * @return Success
   */
  private getProjektRettighederResponse(projektId: string): __Observable<__StrictHttpResponse<PublicProjektRettigheder>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/projekter/${encodeURIComponent(String(projektId))}/rettigheder`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PublicProjektRettigheder>;
      })
    );
  }

  /**
   * Henter rettigheder for et projekt.
   * @param projektId Projektets ID.
   * @return Success
   */
  getProjektRettigheder(projektId: string): __Observable<PublicProjektRettigheder> {
    return this.getProjektRettighederResponse(projektId).pipe(
      __map(_r => _r.body as PublicProjektRettigheder)
    );
  }

  /**
   * Opretter projektinvitation.
   * @param params The `ProjekterService.InviterParams` containing the following parameters:
   *
   * - `projektId`: Projektets ID.
   *
   * - `modtagerNavn`: Navn på modtageren.
   *
   * - `modtagerEmail`: Email på modtageren.
   *
   * - `modtagerRettighed`: Rettighed.
   *
   * - `modtagerMessage`: Besked til modtageren.
   *
   * @return Success
   */
  private inviterResponse(params: ProjekterService.InviterParams): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.modtagerNavn != null) __params = __params.set('modtagerNavn', params.modtagerNavn.toString());
    if (params.modtagerEmail != null) __params = __params.set('modtagerEmail', params.modtagerEmail.toString());
    if (params.modtagerRettighed != null) __params = __params.set('modtagerRettighed', params.modtagerRettighed.toString());
    if (params.modtagerMessage != null) __params = __params.set('modtagerMessage', params.modtagerMessage.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter/${encodeURIComponent(String(params.projektId))}/inviter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Opretter projektinvitation.
   * @param params The `ProjekterService.InviterParams` containing the following parameters:
   *
   * - `projektId`: Projektets ID.
   *
   * - `modtagerNavn`: Navn på modtageren.
   *
   * - `modtagerEmail`: Email på modtageren.
   *
   * - `modtagerRettighed`: Rettighed.
   *
   * - `modtagerMessage`: Besked til modtageren.
   *
   * @return Success
   */
  inviter(params: ProjekterService.InviterParams): __Observable<string> {
    return this.inviterResponse(params).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * Henter rettigheder for et projekt.
   * @param projektId Projektets ID.
   * @return Success
   */
  private getProjektRettighedResponse(projektId: string): __Observable<__StrictHttpResponse<PublicProjektRettighed>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/projekter/${encodeURIComponent(String(projektId))}/rettighed`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PublicProjektRettighed>;
      })
    );
  }

  /**
   * Henter rettigheder for et projekt.
   * @param projektId Projektets ID.
   * @return Success
   */
  getProjektRettighed(projektId: string): __Observable<PublicProjektRettighed> {
    return this.getProjektRettighedResponse(projektId).pipe(
      __map(_r => _r.body as PublicProjektRettighed)
    );
  }

  /**
   * Opdateret projektrettighed.
   * @param params The `ProjekterService.SetProjektRettighedParams` containing the following parameters:
   *
   * - `projektId`:
   *
   * - `publicProjektRettighed`: Projektrettighed som ønskes gemt.
   */
  private setProjektRettighedResponse(params: ProjekterService.SetProjektRettighedParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.publicProjektRettighed;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter/${encodeURIComponent(String(params.projektId))}/setRettighed`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * Opdateret projektrettighed.
   * @param params The `ProjekterService.SetProjektRettighedParams` containing the following parameters:
   *
   * - `projektId`:
   *
   * - `publicProjektRettighed`: Projektrettighed som ønskes gemt.
   */
  setProjektRettighed(params: ProjekterService.SetProjektRettighedParams): __Observable<null> {
    return this.setProjektRettighedResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Sletter en rettighed til projekt.
   * @param params The `ProjekterService.SletProjektRettighedParams` containing the following parameters:
   *
   * - `projektId`:
   *
   * - `publicProjektRettighed`: Projektrettighed som ønskes slettet.
   */
  private sletProjektRettighedResponse(params: ProjekterService.SletProjektRettighedParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.publicProjektRettighed;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter/${encodeURIComponent(String(params.projektId))}/sletRettighed`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * Sletter en rettighed til projekt.
   * @param params The `ProjekterService.SletProjektRettighedParams` containing the following parameters:
   *
   * - `projektId`:
   *
   * - `publicProjektRettighed`: Projektrettighed som ønskes slettet.
   */
  sletProjektRettighed(params: ProjekterService.SletProjektRettighedParams): __Observable<null> {
    return this.sletProjektRettighedResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Accepterer en invitation ud fra ticket.
   * @param ticket Ticket som knytter sig til invitationen.
   * @return Success
   */
  private accepterInvitationResponse(ticket: string): __Observable<__StrictHttpResponse<ActivateProjectInvitationTicketResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (ticket != null) __params = __params.set('ticket', ticket.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/projekter/accepterinvitation`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ActivateProjectInvitationTicketResult>;
      })
    );
  }

  /**
   * Accepterer en invitation ud fra ticket.
   * @param ticket Ticket som knytter sig til invitationen.
   * @return Success
   */
  accepterInvitation(ticket: string): __Observable<ActivateProjectInvitationTicketResult> {
    return this.accepterInvitationResponse(ticket).pipe(
      __map(_r => _r.body as ActivateProjectInvitationTicketResult)
    );
  }

  /**
   * Tilbagekalder invitation.
   * @param invitationId Invitationens ID.
   */
  private tilbagekaldInvitationResponse(invitationId: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter/tilbagekaldinvitation/${encodeURIComponent(String(invitationId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * Tilbagekalder invitation.
   * @param invitationId Invitationens ID.
   */
  tilbagekaldInvitation(invitationId: string): __Observable<null> {
    return this.tilbagekaldInvitationResponse(invitationId).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Opretter projektmappe.
   * @param name Navn på mappe.
   * @return Success
   */
  private createMappeResponse(name: string): __Observable<__StrictHttpResponse<ProjektMappe>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (name != null) __params = __params.set('name', name.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter/opretmappe`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ProjektMappe>;
      })
    );
  }

  /**
   * Opretter projektmappe.
   * @param name Navn på mappe.
   * @return Success
   */
  createMappe(name: string): __Observable<ProjektMappe> {
    return this.createMappeResponse(name).pipe(
      __map(_r => _r.body as ProjektMappe)
    );
  }

  /**
   * Sletter projektmeappe.
   * @param mappe Reference til mappen.
   */
  private deleteMappeResponse(mappe?: ProjektMappeReference): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = mappe;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/projekter/sletmappe`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * Sletter projektmeappe.
   * @param mappe Reference til mappen.
   */
  deleteMappe(mappe?: ProjektMappeReference): __Observable<null> {
    return this.deleteMappeResponse(mappe).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Omdøber mappe.
   * @param params The `ProjekterService.RenameMappeParams` containing the following parameters:
   *
   * - `name`: Nyt navn.
   *
   * - `mappe`: Reference til mappen.
   */
  private renameMappeResponse(params: ProjekterService.RenameMappeParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.name != null) __params = __params.set('name', params.name.toString());
    __body = params.mappe;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter/omdøbmappe`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * Omdøber mappe.
   * @param params The `ProjekterService.RenameMappeParams` containing the following parameters:
   *
   * - `name`: Nyt navn.
   *
   * - `mappe`: Reference til mappen.
   */
  renameMappe(params: ProjekterService.RenameMappeParams): __Observable<null> {
    return this.renameMappeResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Flytter projekter til en projektmappe.
   * @param moveProjekterRequest Indeholder projekter, samt reference til mappen projekterne skal flyttes til.
   */
  private moveProjekterToMappeResponse(moveProjekterRequest?: MoveProjekterRequest): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = moveProjekterRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter/flytprojekter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * Flytter projekter til en projektmappe.
   * @param moveProjekterRequest Indeholder projekter, samt reference til mappen projekterne skal flyttes til.
   */
  moveProjekterToMappe(moveProjekterRequest?: MoveProjekterRequest): __Observable<null> {
    return this.moveProjekterToMappeResponse(moveProjekterRequest).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Henter alle projekter som er tilknyttet brugerens CVR nummer.
   * Hvis brugeren ikke har adgang til virksomhedens projekter returneres 403.
   * @return Success
   */
  private getVirksomhedsProjekterResponse(): __Observable<__StrictHttpResponse<Array<PublicVirksomhedProjekt>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/projekter/virksomhed`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PublicVirksomhedProjekt>>;
      })
    );
  }

  /**
   * Henter alle projekter som er tilknyttet brugerens CVR nummer.
   * Hvis brugeren ikke har adgang til virksomhedens projekter returneres 403.
   * @return Success
   */
  getVirksomhedsProjekter(): __Observable<Array<PublicVirksomhedProjekt>> {
    return this.getVirksomhedsProjekterResponse().pipe(
      __map(_r => _r.body as Array<PublicVirksomhedProjekt>)
    );
  }

  /**
   * @param projektejerRequest undefined
   */
  private setProjektejerResponse(projektejerRequest?: ProjektejerRequest): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = projektejerRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter/setprojektejer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * @param projektejerRequest undefined
   */
  setProjektejer(projektejerRequest?: ProjektejerRequest): __Observable<null> {
    return this.setProjektejerResponse(projektejerRequest).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param projektReference undefined
   * @return Success
   */
  private getForaeldetAktiviteterResponse(projektReference?: ProjektReference): __Observable<__StrictHttpResponse<Array<ForaeldetAktivitetTypePar>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = projektReference;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter/getforaeldetaktivitet`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ForaeldetAktivitetTypePar>>;
      })
    );
  }

  /**
   * @param projektReference undefined
   * @return Success
   */
  getForaeldetAktiviteter(projektReference?: ProjektReference): __Observable<Array<ForaeldetAktivitetTypePar>> {
    return this.getForaeldetAktiviteterResponse(projektReference).pipe(
      __map(_r => _r.body as Array<ForaeldetAktivitetTypePar>)
    );
  }
}

module ProjekterService {

  /**
   * Parameters for omdoeb
   */
  export interface OmdoebParams {

    /**
     * Ny titel.
     */
    projektTitel: string;

    /**
     * Projektets ID.
     */
    projektId: string;
  }

  /**
   * Parameters for setEjendomsejer
   */
  export interface SetEjendomsejerParams {

    /**
     * Projektets ID.
     */
    projektId: string;

    /**
     * ejerskabId.
     */
    ejerskabId: string;
  }

  /**
   * Parameters for setNoEjendomsejer
   */
  export interface SetNoEjendomsejerParams {

    /**
     * Projektets Id.
     */
    projektId: string;

    /**
     * Begrundelse for ikke at have en ejendomsejer.
     */
    ejerskabIkkeSatBegrundelse: string;
  }

  /**
   * Parameters for setProjektKontaktInformation
   */
  export interface SetProjektKontaktInformationParams {
    projektId: string;
    kontaktTlf: string;
    kontaktNavn: string;
    kontaktEmail: string;
    kontaktAdresse: string;
    kontaktCvr?: string;
  }

  /**
   * Parameters for getKonflikter
   */
  export interface GetKonflikterParams {

    /**
     * Projektets ID.
     */
    projektId: string;

    /**
     * Liste af konflikttyper der ønskes konflikter for.
     */
    konfliktTyper?: Array<KonfliktTypeReference>;
  }

  /**
   * Parameters for inviter
   */
  export interface InviterParams {

    /**
     * Projektets ID.
     */
    projektId: string;

    /**
     * Navn på modtageren.
     */
    modtagerNavn: string;

    /**
     * Email på modtageren.
     */
    modtagerEmail: string;

    /**
     * Rettighed.
     */
    modtagerRettighed?: 'ProjektEjer' | 'Ansoeg' | 'Dokumentation' | 'Laes';

    /**
     * Besked til modtageren.
     */
    modtagerMessage?: string;
  }

  /**
   * Parameters for setProjektRettighed
   */
  export interface SetProjektRettighedParams {
    projektId: string;

    /**
     * Projektrettighed som ønskes gemt.
     */
    publicProjektRettighed?: PublicProjektRettighed;
  }

  /**
   * Parameters for sletProjektRettighed
   */
  export interface SletProjektRettighedParams {
    projektId: string;

    /**
     * Projektrettighed som ønskes slettet.
     */
    publicProjektRettighed?: PublicProjektRettighed;
  }

  /**
   * Parameters for renameMappe
   */
  export interface RenameMappeParams {

    /**
     * Nyt navn.
     */
    name: string;

    /**
     * Reference til mappen.
     */
    mappe?: ProjektMappeReference;
  }
}

export { ProjekterService }
